import { addToListActions, CREATE_LIST_OPTION, addToListInitialState } from "./constants.js";
const AddToListReducer = (state, action) => {
  const { type = null, payload = {} } = action || {};
  switch (type) {
    case addToListActions.CHANGE_MODAL_STATE: {
      const { addToListModalOpen } = payload;
      if (!addToListModalOpen) {
        return addToListInitialState;
      }
      return {
        ...state,
        addToListModalOpen,
        isLoading: false
      };
    }
    case addToListActions.UPDATE_QUANTITY: {
      const { quantity = "1" } = payload;
      return {
        ...state,
        isLoading: false,
        quantity
      };
    }
    case addToListActions.CREATE_LIST: {
      return {
        ...state,
        addToListModalMode: addToListActions.CREATE_LIST,
        errorMsg: "",
        hasInputError: false,
        inputErrorText: "",
        isLoading: false,
        showError: false,
        successMsg: ""
      };
    }
    case addToListActions.UPDATE_SELECTED_LIST: {
      const { selectedListId = "", selectedList = "" } = payload;
      if (selectedListId === CREATE_LIST_OPTION) {
        return {
          ...state,
          addToListModalMode: addToListActions.CREATE_LIST,
          errorMsg: "",
          hasInputError: false,
          inputErrorText: "",
          isLoading: false,
          selectedList,
          selectedListId,
          showError: false
        };
      }
      return {
        ...state,
        hasInputError: false,
        inputErrorText: "",
        isLoading: false,
        selectedList,
        selectedListId
      };
    }
    case addToListActions.UPDATE_NEW_LIST_NAME: {
      const { newListName = "" } = payload;
      return {
        ...state,
        errorMsg: "",
        hasInputError: false,
        inputErrorText: "",
        isLoading: false,
        newListName,
        showError: false
      };
    }
    case addToListActions.CHANGE_LOADING_STATE: {
      const { isLoading = false } = payload;
      return {
        ...state,
        isLoading
      };
    }
    case addToListActions.UPDATE_WISH_LIST: {
      const {
        clientIdLegacy = "",
        isLoading = false,
        wishList = []
      } = payload;
      return {
        ...state,
        clientIdLegacy,
        isLoading,
        wishList
      };
    }
    case addToListActions.SHOW_ERROR: {
      const {
        isLoading = false,
        showError = false,
        errorMsg = "",
        hasInputError = false,
        inputErrorText = ""
      } = payload;
      return {
        ...state,
        errorMsg,
        hasInputError,
        inputErrorText,
        isLoading,
        showError
      };
    }
    case addToListActions.UPDATE_DRAWER_CONTENT: {
      const { drawerContent = [] } = payload;
      return {
        ...state,
        drawerContent
      };
    }
    case addToListActions.UPDATE_STATE: {
      return {
        ...state,
        ...payload
      };
    }
    default:
      throw new Error("Error occured with addToList");
  }
};
export {
  AddToListReducer
};
